import { render, staticRenderFns } from "./payment-pagseguro.vue?vue&type=template&id=16375489&scoped=true"
import script from "./payment-pagseguro.vue?vue&type=script&lang=js"
export * from "./payment-pagseguro.vue?vue&type=script&lang=js"
import style0 from "./payment-pagseguro.vue?vue&type=style&index=0&id=16375489&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16375489",
  null
  
)

export default component.exports